import moment from 'moment';
import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { CSVExport, Search } from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useSelector } from 'react-redux';
import Select from 'react-select';
import leftarr from "../../styles/images/leftpagination.svg";
import rightarr from "../../styles/images/rightpagination.svg";
import { ApiServices } from "../../app/base/service/apiService";
import { API_ROUTE_CONTROLLER } from "../../service/route";
import styles from "./scss/voicemail.module.scss";
import Loaders from '../loader';
import { useNavigate } from 'react-router-dom';
const { ExportCSVButton } = CSVExport;

const WorktualCallLogs = () => {
  const navigate =useNavigate();
  const login = useSelector((state: any) => state.login.login);
  const { SearchBar, ClearSearchButton } = Search;
  const [callHistory, setCallHistory] = useState([]);
  const [open, setOpen] = useState<boolean>(false)
  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      Showing {from} to {to} of {size} Results
    </span>
  );
  const [dateFilter, setDateFilter] = useState<any>(0);
  const [dateRanges, setDateRange] = useState<any>([null, null]);
  const [getDate, setDate] = useState<any>(getMindate(new Date()));
  const [startDate, endDate] = dateRanges;
  const [getstartdate, setStartDate] = useState<any>(getDate);
  const [getenddate, setEndDate] = useState<any>(getDate);
  const [datas, setDatas] = useState<any>();
  const [defaultData, setDefaultData] = useState<any>([])
  const [user,setUser]=useState<any>("");
  const [callType,setCalltype]=useState<any>('')
  const [isLoader, setLoader] = useState<boolean>(false);

  const options = {
    paginationSize: 4,
    pageStartIndex: 1,
    firstPageText: 'First',
    prePageText: <img src={leftarr} />,
    nextPageText: <img src={rightarr} />,
    lastPageText: 'Last',
    nextPageTitle: 'First page',
    prePageTitle: 'Pre page',
    firstPageTitle: 'Next page',
    lastPageTitle: 'Last page',
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [
      { text: '10', value: 10 },
      { text: '20', value: 20 },
      { 
        text: 'All', 
        value: callHistory.length && callHistory.length > 0 ? callHistory.length : 10 // Fallback to 10 if callHistory.length is 0 or undefined
      }
    ]
};

  const defaultValue = { value: "ALL", label: 'Call Type' };
  const userSelect: any = [
    { value: "ALL", label: "ALL" },
    { value: "INBOUND", label: "INBOUND" },
    { value: "OUTBOUND", label: "OUTBOUND" }
  ];

  const handleClick = () => {
    setOpen(true)
  }
  const userValue = (e: any) => {
    setCalltype(e.value)
    // User_call_history_Api(user, e.value, getstartdate, getenddate);
  }

  const userChange = (e: any) => {
    setUser(e.value);
    // User_call_history_Api(e.value, callType, getstartdate, getenddate);
  }
  const gotoLogin = () => {
    navigate("/calllogin");
  };


  const defaultDate = { value: "3", label: 'Last 7 days' };
  // const dateRange: any = [
  //   { value: "1", label: "Today" },
  //   { value: "2", label: "Yesterday" },
  //   { value: "3", label: "Last 7 days" },
  //   { value: "4", label: "Last 14 days" },
  //   { value: "5", label: "Last 30 days" },
  //   { value: "6", label: "Custom Date" }
  // ];


  const dateRangeFilter = (e: any) => {
    // console.log('date', e.value);
    // setDateFilter(e.value);
    //const getData = e.map(x => x.value);
    ////console.log("getData", getData.toString());
    // setDateFilter(getData.toString());
    // huntGroupTable(getData.toString(), 0);
    // newUserTableget(optionVal, e.value, hoursFilter, getstartdate, getenddate);
  }

  const setDateRangeFun = async (e: any) => {
    setDateRange(e);
    const start_date = moment(e[0]).format("yyyy-MM-DD");
    const end_date = moment(e[1]).format("yyyy-MM-DD");
    setStartDate(start_date);
    setEndDate(end_date);
    console.log("setDateRangeFun",e,start_date,end_date)
// if(e[1] != null){
//     User_call_history_Api(user, callType, start_date, end_date);
// }
  }

  const [columns, setColumns] = useState([
    { dataField: 'callingNo', text: 'Calling No' },
    { dataField: 'callingno_name', text: 'Calling Name', sort: true },
    { dataField: 'calledNo', text: 'Called No', sort: true },
    { dataField: 'calledno_name', text: 'Called Name', sort: true },
    { dataField: 'callerId', text: 'Caller ID', sort: true },
    { dataField: 'callDateTime', text: 'Call Date Time', sort: true },
    { dataField: 'callDuration', text: 'Call Duration', sort: true },
    { dataField: 'callType', text: 'Call Type', sort: true },
  ]);




  const User_call_history_Api = async (userExt, useType, start_date, end_date) => {
    setLoader(true)
    let _url = API_ROUTE_CONTROLLER.ur_myacc_domain_get_cdr_details_report;
    let _body = {
      p_fromdate: start_date,
      p_todate: end_date,
      p_domainId: 6617,
      p_user_id: userExt == '' ? "200" : userExt,
      p_callType: useType == "" ? "ALL" : useType,
      p_limit: 10000,
      p_offset: 1,
    }

    ApiServices.post(_body, _url).then(async (value: any) => {
      value.data.result[0].map((obj) => {
        obj.callDuration = obj.callDuration / 1000 + " sec";
        const dateString = obj.callDateTime;
        const date = new Date(dateString);

        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');

        const formattedDate = `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
        obj.callDateTime = formattedDate;
      })
      setCallHistory(value.data.result[0])
    setLoader(false)

    }).catch(()=>{
        setLoader(false)

    })
  }
  const today = new Date();
  function getMindate(date: any) {
    const today: any = date;
    const year: any = today?.getFullYear();
    let month: any = today?.getMonth() + 1;
    let day: any = today?.getDate();
    month = month < 10 ? '0' + month : month;
    day = day < 10 ? '0' + day : day;

    return `${year}-${month}-${day}`;
  };


  const search = async (e: any) => {
    User_call_history_Api(user, callType, getstartdate, getenddate);
  };

  const getUsersList = () => {
    setLoader(true)
    let _url = API_ROUTE_CONTROLLER.Urmyaccwebuserorderextension;
    let _body = {
        "OrderId": 14342,
        "Order_Type": "2"
    }
    
    ApiServices.post(_body, _url).then(async (value: any) => {
      if (value.status === 200 && value.data.status_code === 200) {
        if (value.data.finalresponse.length > 0) {
          let array = value.data.finalresponse.map((obj: any) => {
            return { label: obj.name, value: obj.ext_number }
          })
          setDefaultData(array[0])
          setDatas(array);
          setLoader(false)
          User_call_history_Api("200", defaultValue.value, getstartdate, getenddate);
        } else {
          setDatas([]);
          setLoader(false)

        }

      }
    })
  }


  useEffect(() => {
    const login:any = sessionStorage.getItem("login");
    console.log("login",login)
    if ((login !== "nair") || login == null  ) {
      navigate("/calllogin");
    }
    getUsersList();
    setDate(getMindate(today))
  }, []);
  return (
    <>
    <div className="allinone allinlogout">
        <svg
          width="114"
          height="26"
          viewBox="0 0 114 26"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M25.8855 4.73577V17.3682H17.1919V13.4661C17.1919 10.8523 15.0801 8.73134 12.4766 8.73134H8.59137V0H21.1702C23.7737 0 25.8855 2.11996 25.8855 4.73577Z"
            fill="#00E2A4"
          />
          <path
            d="M17.1919 17.3672V26L8.59546 17.3672H17.1919Z"
            fill="#00E2A4"
          />
          <path
            d="M17.1919 13.4651C17.1919 10.8503 15.0811 8.73035 12.4777 8.73035H8.59239L8.59546 8.73343H0V17.3662H8.59546V8.73445L17.1909 17.3672V13.4651H17.1919Z"
            fill="black"
          />
          <path
            d="M46.9985 5.39282L44.8315 13.2444L42.827 5.67822H39.3322L37.3277 13.2444L35.1198 5.39282H31.5146L35.7065 20.445H38.3795L41.0791 12.6951L43.7582 20.445H46.4516L50.6435 5.39282H46.9985ZM54.1823 10.1122C51.3059 10.1122 48.957 12.4713 48.957 15.3602C48.957 18.2491 51.3059 20.6083 54.1823 20.6083C57.0587 20.6083 59.4077 18.2491 59.4077 15.3602C59.4077 12.4713 57.0587 10.1122 54.1823 10.1122ZM54.1823 17.3128C53.109 17.3128 52.2381 16.4382 52.2381 15.3602C52.2381 14.2823 53.109 13.4076 54.1823 13.4076C55.2556 13.4076 56.1265 14.2823 56.1265 15.3602C56.1265 16.4382 55.2556 17.3128 54.1823 17.3128ZM81.6767 7.04054H78.3955V16.1528C78.3955 19.1227 79.894 20.444 82.5067 20.444H84.4304V17.1486H82.6079C82.0406 17.1486 81.6767 16.742 81.6767 16.1928V13.1417H84.5531V10.2733H81.6767V7.03951V7.04054ZM107.256 10.2744H104.501V10.7425C103.731 10.3349 102.922 10.1111 102.03 10.1111C99.1548 10.1111 96.8263 12.4498 96.8263 15.3387C96.8263 18.2275 99.1548 20.6072 102.03 20.6072C102.961 20.6072 103.772 20.3424 104.542 19.9553V20.444H107.891V17.4648H107.256V10.2744ZM102.11 17.3118C101.038 17.3118 100.186 16.4371 100.186 15.3387C100.186 14.2402 101.037 13.385 102.11 13.385C103.183 13.385 104.055 14.2597 104.055 15.3387C104.055 16.4176 103.184 17.3118 102.11 17.3118ZM113.271 17.1486C112.785 17.1486 112.541 16.8231 112.541 16.355V6.20693H108.625V9.18616H109.261V16.315C109.261 19.1833 110.293 20.444 113.17 20.444H113.959V17.1486H113.27H113.271ZM62.9372 10.7415V10.2733H59.791V13.2526H60.4268V20.443H63.667V14.5851C63.667 13.9147 64.2149 13.385 64.8824 13.385H66.2184V10.2733H64.7608C64.1321 10.2733 63.525 10.375 62.9372 10.7415ZM77.3785 10.2733H73.4901L70.7221 12.9785V6.20693H66.8072V9.18616H67.4419V20.444H70.7231V17.5356L71.3599 16.9155L73.9164 20.444H77.8855L73.5515 14.7083L77.3785 10.2744V10.2733ZM92.4504 16.1107C92.4504 16.7821 91.9035 17.3313 91.235 17.3313C90.5665 17.3313 90.0207 16.781 90.0207 16.1107V10.2733H86.1232V13.2526H86.761V16.1107C86.761 18.592 88.7655 20.6062 91.2361 20.6062C93.7067 20.6062 95.7122 18.592 95.7122 16.1107V10.2733H92.4514V16.1107H92.4504Z"
            fill="black"
          />
        </svg>
        <Col sm={3} className={styles.leftlogoout}>
        <button onClick={()=>{navigate("/worktualcall_log")}}>Call Recording logs</button>
          <button onClick={gotoLogin}>Logout</button>
        </Col>
      </div>
      <Row className="breadcrumbarea">
        <Col sm={12}>
          <h4>Call Logs</h4>
        </Col>
      </Row>

      <div className={styles.scrolldiv}>
        <ToolkitProvider keyField="SIP_ID" data={callHistory} columns={columns} search={{ defaultSearch: '' }} exportCSV={{
          fileName: 'Call_Logs.csv',
          ignoreHeader: false,
          noAutoBOM: false
        }}>
          {(props: any) => (
            <>
              <div className={`${styles.toplayers} ${styles.toplayerscallog}`}>
                <div className={styles.lefts}>
                    <div className={styles.elems}>
                        <Select menuShouldScrollIntoView={false} className="regularselect" options={datas}
                    defaultValue={defaultData} onChange={userChange} placeholder="Select User" />
                    </div>

                    <div className={styles.elems}>
                        <Select menuShouldScrollIntoView={false} className="regularselect" options={userSelect} defaultValue={defaultValue} onChange={userValue} placeholder="Select Type" isSearchable={false} />
                    </div>

                    <div className={styles.elems}>
                    <DatePicker
                    selectsRange={true}
                    startDate={startDate}
                    endDate={endDate}

                    maxDate={new Date()}
                    dateFormat="dd-MM-yyyy"
                    onClick={handleClick()}
                    // onChange={(update) => {
                    //   setDateRange(update);
                    // }}
                    onChange={(update) => {
                      setDateRangeFun(update);
                    }}
                    placeholderText="Choose Date"
                    isClearable={true}
                    isSearchable={false} // Disable search

                    shouldCloseOnSelect={true}

                    onKeyDown={(e) => {
                      e.preventDefault();
                    }}
                  />
                    </div>
                    <div className={styles.elems}>
                    <button onClick={search}>Search</button>
                  </div>

                  {/* <div className="searchclear">
                    <SearchBar {...props.searchProps} />
                    <ClearSearchButton {...props.searchProps} className="clears" />
                  </div> */}
                </div>
                  {/* <div className="searchclear">
                    <SearchBar {...props.searchProps} />
                    <ClearSearchButton {...props.searchProps} className="clears" />
                  </div> */}
                  
                  

                <div className={styles.rights}>
                  <ExportCSVButton {...props.csvProps}>Export</ExportCSVButton>
                </div>
              </div>
              <div className='worktuallogtable'>
                  <BootstrapTable
                    {...props.baseProps}
                    pagination={paginationFactory(options)}
                    noDataIndication="No data found" />
              </div>

            </>
          )}
        </ToolkitProvider>

        {isLoader == true ? <Loaders></Loaders> : ""}

      </div>

    </>
  )


}
export default WorktualCallLogs;